import { ValueDefinitionModel } from '@/domain/models';
function createValueDefinition(id) {
    const newValue = new ValueDefinitionModel();
    newValue.id = id;
    return newValue;
}
function createValueDefinitionString(text) {
    try {
        return createValueDefinition(parseInt(text));
    }
    catch (error) {
        return createValueDefinition(0);
    }
}
export { createValueDefinition, createValueDefinitionString };
